import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const defaultApproachData = [
    {
        id: 1,
        title: "Architecture Before Implementation",
        desc: "We align your Databricks platform with business goals, cloud architecture, data sources, and long-term scale.",
    },
    {
        id: 2,
        title: "Security and Governance by Design",
        desc: "Unity Catalog, fine-grained access controls, automated compliance, and auditability configured from day one.",
    },
    {
        id: 3,
        title: "Production-Ready Engineering",
        desc: "CI/CD pipelines, robust orchestration, testing frameworks, and monitoring built for operational excellence.",
    },
    {
        id: 4,
        title: "From Strategy to Go-Live",
        desc: "End-to-end guidance and hands-on enablement ensuring your teams take full ownership with zero downtime.",
    },
];

export const ApproachSection = ({
    badge = "The Mobikode approach",
    heading = "Built for real-world data and AI delivery",
    bgImageSrc = "/assets/datab/bg2.png",
    approachData = defaultApproachData,
}) => {
    const [activeTab, setActiveTab] = useState(0);

    return (
        <section className="w-full bg-white py-[50px] lg:py-[50px]">
            <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">
                <div className="mb-8 lg:mb-12">
                    <span className="block text-[#ED6800] font-graphik text-[14px] md:text-[16px] font-[500] mb-2 sm:mb-3">
                        {badge}
                    </span>
                    <h2 className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] font-sora leading-[1.18] tracking-[-0.02em]">
                        {heading}
                    </h2>
                </div>

                <div className="relative w-full overflow-hidden bg-[#021029] min-h-[360px] lg:min-h-[467px] flex flex-col justify-end">
                    <div className="absolute inset-0 z-0 pointer-events-none">
                        <img
                            src={bgImageSrc}
                            alt="Data and AI delivery background"
                            className="w-full h-full object-cover object-center"
                        />
                    </div>

                    <div className="relative z-10 w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 items-end">
                        {approachData.map((item, index) => {
                            const isActive = activeTab === index;

                            return (
                                <div
                                    key={item.id}
                                    onMouseEnter={() => setActiveTab(index)}
                                    className={`relative cursor-pointer transition-colors duration-300 border-t border-[#FFFFFF] lg:border-t-0 sm:border-r last:border-r-0 ${isActive ? "bg-[#01254A]" : "bg-[#01254A] hover:bg-[#01254A]"
                                        } p-6 sm:p-7 lg:p-8 flex flex-col justify-end min-h-[140px] lg:min-h-[170px]`}
                                >
                                    <h3 className="text-white text-[16px] lg:text-[20px] font-[600] font-sora leading-[1.3] mb-0">
                                        {item.title}
                                    </h3>

                                    <AnimatePresence>
                                        {isActive && (
                                            <motion.div
                                                initial={{ opacity: 0, height: 0 }}
                                                animate={{ opacity: 1, height: "auto" }}
                                                exit={{ opacity: 0, height: 0 }}
                                                transition={{ duration: 0.35, ease: "easeInOut" }}
                                                className="overflow-hidden"
                                            >
                                                <p className="text-white font-graphik text-[14px] md:text-[16px] font-[500] leading-[1.6] pt-4">
                                                    {item.desc}
                                                </p>
                                            </motion.div>
                                        )}
                                    </AnimatePresence>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ApproachSection;